import React from 'react';

import { Row, Col } from 'reactstrap';
import { TransparentContainer } from 'components/common/TransparentContainer';
import { Header } from './atoms/Header';
import { Heading } from './atoms/Heading';

interface Props {
    center?: boolean;
    title: string;
}
export const TitleHeader: React.FC<Props> = ({ title, ...props }) => {
    return (
        <Header>
            <TransparentContainer>
                <Row>
                    <Col sm={12} lg={{ size: 8, offset: 2 }}>
                        <Heading {...props}>{title}</Heading>
                    </Col>
                </Row>
            </TransparentContainer>
        </Header>
    );
};
